import dayjs from 'dayjs';

import { useReportCapabilitiesQuery } from 'hooks/queries/cost';

import { useWasEnabled } from './useWasEnabled';
import { OnboardingPhase2HookProps } from '../types';

export const useWasReliabilityMetricsInstalled = ({
  clusterId,
  onSuccess,
  onError,
  enabled,
}: OnboardingPhase2HookProps): boolean => {
  const { data, error } = useReportCapabilitiesQuery({
    clusterId,
    startTime: dayjs().startOf('hour').toISOString(),
    endTime: dayjs().startOf('hour').add(1, 'hour').toISOString(),
    refetchInterval: enabled ? 20_000 : false,
    enabled,
  });

  const isReliabilityMetricsInstalled = Boolean(
    data?.reliabilityMetricsDataAvailable
  );

  useWasEnabled({
    currentState: isReliabilityMetricsInstalled,
    onSuccess: onSuccess,
    onError: onError,
    error,
    enabled,
  });

  return isReliabilityMetricsInstalled;
};
